import { render, staticRenderFns } from "./UserProfileV2.vue?vue&type=template&id=53bb3305&scoped=true"
import script from "./UserProfileV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserProfileV2.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UserProfileV2.vue?vue&type=style&index=0&id=53bb3305&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bb3305",
  null
  
)

export default component.exports